import React, { useState, useEffect } from "react";
import {
  Testimonial1,
  Testimonial2,
  Testimonial3,
  Testimonial4,
  Testimonial5,
} from "assets/img";

const Testimonial = ({ currentStep }) => {
  const [imageIcon, setImageIcon] = useState();

  useEffect(() => {
    if (currentStep == 1) setImageIcon(Testimonial1);
    else if (currentStep == 2) setImageIcon(Testimonial2);
    else if (currentStep == 3) setImageIcon(Testimonial3);
    else if (currentStep == 4) setImageIcon(Testimonial4);
    else if (currentStep == 5) setImageIcon(Testimonial5);
  }, [currentStep]);

  return (
    <>
      {currentStep !== 4 ? (
        <div className="flex justify-center items-center">
          <img className="w-11/12 h-80" src={imageIcon} />
        </div>
      ) : (
        <div className="flex justify-center items-center">
          <img className="w-[390px] h-[490px]" src={imageIcon} />
        </div>
      )}
    </>
  );
};

export default Testimonial;
